import React from "react";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import IconCustom from "../../../../../../../Utils/IconCustom/IconCustom";

const types = {
    string: "abc",
    number: "123.12",
    integer: "123",
    object: "{}",
    entityExternal: "<->",
    script: "</>",
    date: "01-01-2021",
    datetime: "01-01-2021 00:00.000",
    entityEmbedded: "->_",
    bool: "true/false"
};
const componentStyles = {display: 'flex', justifyContent: "space-between", alignItems: 'center', width: '80%'};

const ItemComponent = ({item, disabled}) => {
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(item.label, userLanguage)
    return (
        <div style={{...componentStyles, opacity: disabled ? 0.5 : 1}} onContextMenu={(e) => {
            e.preventDefault()
        }}>
            <span>{multiLanguageLabel || <>&nbsp;</>}</span>
            <div style={{display: 'flex', alignItems: 'center'}}>
                {item.overridable && (
                    <IconCustom iconType={'symbols-outlined'}>wrap_text</IconCustom>
                )}
                <input disabled style={{height: 22}} placeholder={types[item.type] || ""}/>
            </div>
        </div>
    )
};
export default ItemComponent